import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Rajah and TannSection section on Partners page
 */
const RajahAndTannSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="rajah-and-tann-section-component">
      <AccordionV2
        testId="rajah-and-tann"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Rajah & Tann Legal Basix"
            className="px-0"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            Rajah & Tann Legal Basix is a specialised practice of Rajah & Tann
            that is focused on providing baseline and growth-stage legal advice,
            representation and documentation to businesses, from emerging
            enterprises, start-ups and SMEs to high growth companies. We assist
            businesses in six core areas: corporate, dispute resolution,
            e-commerce, employment, intellectual property and regional
            expansion. Legal Basix leverages on the deep expertise and
            experience of Rajah & Tann’s award-winning practice groups and
            knowledge leaders to deliver distilled, right-sized, growth stage
            appropriate legal solutions for our clients.
          </p>

          <p>Legal Basix is Legal, Simplified.</p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default RajahAndTannSection;
